<template>
  <div class="header">
    <div class="container">
      <b-navbar toggleable="lg" type="dark" variant="">
        <!-- <b-navbar-brand href="#">NavBar</b-navbar-brand> -->
        <b-navbar-brand :to="{ name: 'Dashboard' }">
          <img src="../../assets/randd.png" alt="logo">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <b-navbar-nav>
            <b-nav-item :to="{ name: 'Dashboard' }"><font-awesome-icon icon="home" /> Home</b-nav-item>
            <b-nav-item :to="{ name: 'Search' }"><font-awesome-icon icon="search" /> Search</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <b-nav-item :to="{ name: 'MyCallbacks' }">Callbacks <span v-if="callbackCount" class="callbackcount" :class="{'late':callbackCount.isLate }">{{callbackCount.count}}</span></b-nav-item>
            <!-- <b-nav-item href="#">Parked</b-nav-item> -->
            <b-nav-item-dropdown right>
              <template #button-content><font-awesome-icon icon="user" /> {{userName}}</template>
              <b-dropdown-item @click="phoneSettingsModal"><font-awesome-icon icon="phone" /> Telephone</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item :to="{ name: 'Logout' }"><font-awesome-icon icon="unlock" /> Log Out</b-nav-item>

          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <PhoneSettingsModal ref="phoneSettingsModal" />
  </div>
</template>

<script>

  import store from '@/helpers/Store'
  import PhoneSettingsModal from "@/components/shared/PhoneSettingsModal.vue";

  export default {
    name: "Header",
    components: { PhoneSettingsModal },
    props: {
      user: String,
      callbackCount: Object
    },
    data() {
      return {
      }
    },
    computed: {
      userName() {
        return store.state.userName;
      }
    },
    methods: {
      phoneSettingsModal() {
        this.$refs.phoneSettingsModal.showModal();
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    width: 100%;
    background-color: #252658;
    height: 60px;
    margin-bottom: 12px;
  }

  .username {
    cursor: context-menu !important;
  }

  .callbackcount {
    background: rgba(255, 255, 255, 0.5);
    padding: 0 5px 3px 5px;
    border-radius: 48px;
    color: #252658;
  }

    .callbackcount.late {
      color: rgba(255, 255, 255, 0.5);
      background-color: #dc3545;
    }
</style>
